define(
  'app/views/location_deals_list_view',['app/setup'],
  function(takhfifan) {

  takhfifan.LocationDealsListView = takhfifan.BaseView.extend({

    initialize: function(options) {
      var _this = this;
      takhfifan.eventHub.on('location:loadMap', function() {
        _this.notifyMap();
      });

      takhfifan.eventHub.on('location:showCategory', function(opts) {
        _this.showProducts(opts.categoryId);
      });

      takhfifan.eventHub.on('location:hideCategory', function(opts) {
        _this.hideProducts(opts.categoryId);
      });

      this.$el.scroll(function(){
        takhfifan.eventHub.trigger('lazyLoad:notify');
      });
    },

    hideProducts: function(categoryId) {
      var $products = this.$el.find('.tkh-location-deal-view[data-categoryId="' + categoryId + '"]');
      if (categoryId == '-1') {
        $products = this.$el.find('.tkh-location-deal-view'); 
      }
      $products.hide();
      this.notifyMap();
    },

    showProducts: function(categoryId) {
      var $products = this.$el.find('.tkh-location-deal-view[data-categoryId="' + categoryId + '"]');
      if (categoryId == '-1') {
        $products = this.$el.find('.tkh-location-deal-view'); 
      }
      $products.show();
      this.notifyMap();
    },

    notifyMap: function() {
      var $visibleProducts = this.$el.find('.tkh-location-deal-view:visible');
      var productsDetails = [];
      for (i = 0; i < $visibleProducts.length; i++) {
        var product = $visibleProducts[i];
        var temp = {
          title: product.dataset.title,
          categoryIcon: product.dataset.categoryicon,
          url: product.dataset.producturl,
          latitude: product.dataset.latitude, 
          longitude: product.dataset.longitude,
          imgUrl: product.dataset.imageurl,
          price: product.dataset.price
        };
        productsDetails.push(temp);
      }
      takhfifan.eventHub.trigger('location:updateMap', productsDetails);
    }

  });
});

